export const topics_list = [
    "Basics",
    "Matrix Exponentiation",
    "FFT",
    "NTT",
    "Online NTT",
    "FWHT",
    "Lagrange Interpolation",
    "Lagrange Interpolation with Polynomial Extraction",
    "Polynomial Sum",
    "Polynomial with Binomial Coefficients",
    "Subset Sum Problem",
    "Generating Functions",
    "Polynomial Structure",
    "Polynomial Factorization of (x^n — 1)",
    "Berlekamp Messey",
    "Reeds–Sloane Algorithm",
    "Linear Recurrence using Cayley-Hamilton theorem",
    "Linear Recurrence using Generating Functions",
    "Linear Recurrence with Polynomial Coefficients",
    "Linear Recurrence on Matrices",
    "Generating Function of a Linear Recurrence",
    "Gaussian Elimination",
    "Gaussian Elimination under Modulo",
    "Gaussian Elimination Modulo 2",
    "Determinant under Prime Modulo",
    "Determinant under Composite Modulo",
    "Determinant of Product Matrix",
    "Determinant of Sparse Matrix",
    "Determinant of Permutant Matrix",
    "Determinant of Cyclic Matrix",
    "Cauchy–Binet formula",
    "Thomas Algorithm",
    "Inverse of a Matrix",
    "Inverse of a Matrix modulo 2",
    "Basis Vector",
    "Basis Vector Reduced Row Echelon Form.",
    "Basis Vector ft Weighted Linearly Independent Vectors.",
    "Permanent of a Matrix",
    "All Possible Perfect Matching XOR Values",
    "Hafnian of a Matrix",
    "Vandermonde Matrix",
    "Freivalds Algorithm",
    "Characteristic Polynomial Faster / Hesserberg Matrix",
    "Faulhaber's Formula Fastest",
    "Lagrange Multiplier",
    "Titu's Lemma",
    "Simplex Algorithm",
    "Integration",
    "Line Integral",
    "The Slime Trick",
    "Gauss's Eureka Theorem",
    "LTE Lemma",
    "Expected Value",
    "Expected Value Powers Technique",
    "Finite Field Arithmetic Binary",
    "Max Convolution between Convex Funtions",
    "Binary Exponentiation",
    "Modular Inverse",
    "Sieve",
    "Sieve upto 1e9",
    "Extended Euclid",
    "Combinatorics Basics",
    "Lucas Theorem",
    "nCr Modulo Any Mod",
    "Prefix Sum Queries of nCi",
    "Sum of nCi over a Fixed Congruence Class",
    "\"Sum of nCr(a(i) k) for each k from 1 to n\"",
    "Sum of nCi for a Fixed Large n",
    "Phi Function",
    "Power Tower",
    "Mobius Function",
    "CRT",
    "Linear Congruence Equation",
    "Pollard Rho",
    "Primitive Root",
    "Multiplicative Order / Carmichael's Lambda Function",
    "Discrete Log",
    "Discrete Root",
    "Discrete Root in O(p^(1/4)) using Tonelli-Shanks Algorithm",
    "Number of Distinct Kth Powers Modulo n",
    "Number of Solutions to x^2 = 1 mod m",
    "Tonelli Shanks Algorithm",
    "Pells Equation",
    "Linear Diophantine Equation with Two Variables",
    "Trivariable Linear Diophantine Equation with Nonnegative Solutions",
    "Multivariable Linear Diophantine Equation with Nonnegative Solutions",
    "Linear Diophantine With N Unknowns and Two Equations",
    "Floor Sum of Arithmetic Progression",
    "Generalized Floor Sum of Arithmetic Progression",
    "Sum of Floors",
    "Number of Nonnegative Integer Solutions to ax+by ≤ c",
    "Number of ax % p in a Range",
    "Smallest Nonnegative Integer x s.t. l ≤ ax % p ≤ r",
    "Prime Counting Function",
    "K Divisors",
    "Smallest Number Having Exactly K Divisors",
    "Sum of The Number of Divisors in cbrt(n)",
    "Linear Sieve for Multiplicative Functions",
    "Min_25 Sieve",
    "Mobius Inversion",
    "Dirichlet convolution",
    "Number of Solutions to a Basic Linear Algebraic Equation",
    "Number of Solutions to a Basic Linear Algebraic Equation with Variable Upper Bound Constraints",
    "Partition Function",
    "Stirling Number of the First Kind for Fixed n",
    "Stirling Number of the First Kind for Fixed k",
    "Stirling Number of the Second Kind for Fixed n",
    "Stirling Number of the Second Kind for Fixed k",
    "Bell Number",
    "LCM of Fibonacci Numbers",
    "Phi Field",
    "Pisano Period",
    "Rational Approximation / Stern-Brocot Tree",
    "Factoradic Number System",
    "Intersection of Arithmetic Progressions",
    "Continued Fractions",
    "Maximum Coprime Product",
    "DFS and BFS",
    "0/1 BFS",
    "Dial's algorithm",
    "Inverse Graph",
    "LCA",
    "LCA in O(1)",
    "SCC",
    "Incremental SCC",
    "DFS Tree",
    "Rerooting Technique",
    "Articulation Bridges and Bridge Tree",
    "Online Articulation Bridges",
    "Strong Orientation",
    "Articulation Points.",
    "Block Cut Tree",
    "Three Edge Connectivity",
    "Four Edge Connectivity",
    "Dynamic K-Connectivity",
    "Prim's MST",
    "Krushkal's MST",
    "Steiner Tree Problem",
    "Boruvka's Algorithm",
    "Minimum Diameter Spanning Tree",
    "Manhattan MST",
    "Euclidean MST",
    "Directed MST",
    "Dynamic MST",
    "Dijkstra's Algorithm",
    "Dijkstra on Segment Tree",
    "Bellman Ford",
    "Floyd Warshall",
    "Johnsons Alogrithm",
    "SPFA",
    "Cycle Detection",
    "Minimum Weight Cycle For Each Vertex",
    "Minimum Weight Cycle For Each Edge",
    "Dominator tree",
    "2 SAT",
    "3 SAT",
    "Maximum Clique",
    "Number of Different Cliques",
    "Maximum Independent Set",
    "Eulerian Path on a Directed Graph",
    "Eulerian Path on an Undirected Graph",
    "Path Union",
    "Path Intersection",
    "Virtual Tree",
    "Welsh-Powell Algorithm",
    "Chromatic Number",
    "Chromatic Polynoimial ft Number of DAGs",
    "Dynamic DAG Reachability",
    "Minimum Mean Weight Cycle",
    "Number of 3 and 4 length Cycles",
    "Counting Labeled Graphs",
    "Chordal Graph",
    "Cactus Graph",
    "Edge Coloring of Simple Graph",
    "Edge Coloring of Bipartite Graph",
    "Dynamic Diameter Online",
    "Tree Orientation to Maximize Pairs of Reachable Nodes",
    "Number of Arborescences with n Nodes",
    "Kirchoffs Theorem ft Number of MSTs",
    "Tuttes Theorem ft Arborescences in a Graph",
    "BEST Theorem",
    "System Of Difference Constraints",
    "Prufer Code",
    "Number of Ways to Make a Graph Connected",
    "Tree Isomorphism",
    "Number of Paths of Each Length in a Tree",
    "Ear Decomposition",
    "Eppsteins Algorithm",
    "Hamiltonian Path Heuristic Algorithm",
    "Erdos Gallai Theorem",
    "Havel Hakimi Algorithm",
    "Dinics Algorithm",
    "Push Relabel Algorithm",
    "Min Cost Max Flow",
    "Min Cost Max Flow with Negative Cycles",
    "Maximum Closure Problem",
    "Min Cut in a Planar Graph",
    "Max Cut in a Planar Graph",
    "Unique Min Cut",
    "L-R Flow",
    "Gomory-Hu Tree",
    "Gomory Hu Tree of a Planar Graph",
    "Stoer Wagner Algorithm",
    "HopCroft Karp Algorithm",
    "Kuhns Algorithm",
    "Hungarian Algorithm",
    "Blossom Algorithm",
    "Blossom Algorithm Weighted",
    "Chinese Postman Problem",
    "ST-numbering",
    "POSET ft Dilworths and Mirskys Theorem",
    "Stable Marriage Problem",
    "Halls Theorem",
    "Maximum Density Subgraph",
    "Randomized Matching",
    "Number of Perfect Matchings in a Graph",
    "Planarity Check",
    "Segment Tree",
    "Segment Tree with Lazy Propagation",
    "Persistent Segment Tree",
    "Persistent Segment Tree with Lazy Propagation",
    "Dynamic Segment Tree",
    "2D Dynamic Segment Tree",
    "Iterative Segment Tree",
    "Segment Tree ft Arithmetic Progressions",
    "Segment Tree Merging",
    "Segment Tree Beats",
    "Merge Sort Tree",
    "Wavelet Tree",
    "Sparse Table",
    "Disjoint Sparse Table",
    "Sparse Table 2D",
    "BIT",
    "Lower bound on BIT",
    "BIT with Range Update and Range Query",
    "2D BIT with Range Update and Range Query",
    "MOs Algorithm",
    "MOs on Tree",
    "MOs with Update",
    "MOs Online",
    "MOs with DSU",
    "Sweepline MO",
    "Trie",
    "Persistent Trie",
    "DSU",
    "Reachability Tree/ DSU Tree",
    "DSU with Rollbacks",
    "Partially Persistent DSU",
    "Persistent DSU",
    "Augmented DSU",
    "Queue Undo Trick",
    "Dynamic Connectivity Problem",
    "DSU on Tree",
    "SQRT Decomposition",
    "SQRT Decomposition Split and Build Technique",
    "Centroid Decomposition",
    "Persistent Centroid Decomposition",
    "Binarizing a Tree",
    "HLD ft Subtrees and Path Query",
    "HLD ft Persistent Lazy Propagation",
    "LCT",
    "Treap",
    "Implicit Treap",
    "Persistent Treap",
    "SQRT Tree",
    "KD Tree",
    "Cartesian Tree",
    "Rope",
    "Monotonous Queue",
    "BST using STL",
    "Persistent BST",
    "Ordered Set",
    "Static to Dynamic Trick",
    "Interval Set",
    "Divide and Conquer on Queries",
    "Divide and Conquer for Insert and Query Problems",
    "Venice Technique",
    "Permutation Tree",
    "Persistent Array",
    "Persistent Queue",
    "Persistent Meldable Heap",
    "Top Tree",
    "PQ Tree",
    "Link Cut Cactus",
    "HDLT",
    "KMP",
    "Prefix Automaton",
    "Z algorithm",
    "Aho Corasick",
    "Dynamic Aho Corasick",
    "Aho Corasick ft All Pair Occurrence Relation",
    "String Matching using Bitsets",
    "String Matching with FFT",
    "String Hashing",
    "2D String Hashing",
    "Suffix Array",
    "Isomorphic Suffix Array",
    "Suffix Automaton",
    "Suffix Automaton ft Distinct Substring Queries in Range.",
    "Suffix Tree",
    "Palindromic Tree",
    "Persistent Palindromic Tree",
    "Manachers Algorithm",
    "Minimum Palindrome Factorization",
    "Number of Palindromes in Range",
    "Lyndon Factorization",
    "Main-Lorentz Algorithm",
    "All Substring Longest Common Subsequence",
    "Bit LCS",
    "Cyclic LCS",
    "De Bruijn Sequence",
    " LCS on RLE compressed string",
    "Digit DP",
    "CHT",
    "Dynamic CHT",
    "Persistent CHT",
    "Li Chao Tree",
    "Persistent Li Chao Tree",
    "Extended Li Chao tree",
    "Divide and Conquer Optimization",
    "Knuth Optimization",
    "Substring DP",
    "Bounded Knapsack",
    "SOS DP",
    "Subset Sum Convolution",
    "Dynamic Submask Count",
    "DP over Divisors",
    "Subset Sum in SQRT",
    "LIS Range Query",
    "Aliens Trick",
    "1D1D DP Optimization",
    "Connected Component DP",
    "Slope Trick",
    "Subset Union of Bitsets",
    "Number of Subsequences Having Product at least K",
    "Hirschbergs Algorithm",
    "Broken Profile DP/plug dp",
    "XOR Equation",
    "\"x2 +1 trick\"",
    "Open and Close Interval Trick",
    "Bitmask DP",
    "Geometry 2D Everything",
    "Basic Point Structure(2D)",
    "Polar Sort(2D)",
    "Basic Line Structure(2D)",
    "Angle Bisector(2D)",
    "Dist from Point to Line(2D)",
    "Dist from Point to Ray(2D)",
    "Dist from Point to Segment(2D)",
    "Dist from Segment to Segment(2D)",
    "Check if Point is on Segment(2D)",
    "Line Line Intersection(2D)",
    "Point Line Relation(2D)",
    "Project from Point to Line(2D)",
    "Project from Point to Segment(2D)",
    "Ray Ray Distance(2D)",
    "Ray Ray Intersection(2D)",
    "Reflection from Point to Line(2D)",
    "Segment Line Intersection(2D)",
    "Segment Line Relation(2D)",
    "Segment Segment Intersection(2D)",
    "Basic Circle Structure(2D)",
    "Circle Circle Area(2D)",
    "Circle Circle Intersection(2D)",
    "Circle Circle Relation(2D)",
    "Circle Line Intersection(2D)",
    "Circle Line Relation(2D)",
    "Circle Point Relation(2D)",
    "Tangent Lines from Point(2D)",
    "Tangent Lines from Circle(2D)",
    "Maximum Circle Cover(2D)",
    "Maximum Inscribed Circle(2D)",
    "Triangle Circle Intersection(2D)",
    "Polygon Circle Intersection(2D)",
    "Circle Union(2D)",
    "Centroid of a Polygon(2D)",
    "Convex Hull(2D)",
    "Diameter of a Convex Polygon(2D)",
    "Extreme Vertex(2D)",
    "Geometric Median(2D)",
    "Convexity Check(2D)",
    "Check if Point is in Convex(2D)",
    "Check if Point is in Polygon(2D)",
    "Minimum Enclosing Circle(2D)",
    "Minimum Enclosing Rectangle(2D)",
    "Polygon Line Intersection(2D)",
    "Width of a Polygon(2D)",
    "Winding Number(2D)",
    "Dist from Point to Polygon(2D)",
    "Dist from Polygon to Line(2D)",
    "Dist from Polygon to Polygon(2D)",
    "Maximum Dist from Polygon to Polygon(2D)",
    "Tangents from Point to Polygon(2D)",
    "Polygon Union(2D)",
    "Minkwoski Sum(2D)",
    "Geometry 3D Everything",
    "Basic Point Structure(3D)",
    "Basic Line Structure(3D)",
    "Plane Structure(3D)",
    "3D Coordinates to 2D ",
    "Distance from Segment to Point(3D)",
    "Distance from Triangle to Point(3D)",
    "Distance from Triangle to Segment(3D)",
    "Distance from Triangle to Triangle(3D)",
    "Distance from Segment to Segment(3D)",
    "Plane Plane Intersection",
    "Basic Sphere Structure",
    "Sphere Line Intersection",
    "Segment Segment Intersection on Sphere",
    "Oriented Angle on Sphere",
    "Area on The Surface of The Sphere",
    "Winding Number 3D",
    "Convex Hull 3D",
    "Picks Theorem",
    "Closest Pair of Points",
    "All Pair Segment Intersection.",
    "Dynamic Convex Hull",
    "Delaunay Triangulation",
    "Voronoi Diagram",
    "Half Plane Intersection",
    "Dynamic Half Plane Intersection",
    "Onion Decomposition",
    "Point Location",
    "Convex Hull Intersection using Minkowski",
    "Generating Points without Collinear Triplets",
    "Maximum Area of a Triangle from given Lengths",
    "Vertical decomposition",
    "Green Hackenbush on Trees and Graphs",
    "Blue Red HackenBush",
    "Games on Arbitrary Graphs",
    "Matching Game On A Graph",
    "Nimber",
    "Bigint",
    "Two Pointers",
    "Binary Search",
    "Fraction Binary Search",
    "Ternary Search",
    "Parallel Binary Search",
    "Josephus Problem",
    "Permutation with no Arithmetic Progression",
    "Balanced Brackets",
    "Knight Moves in Infinity Grid",
    "Bishop Placement",
    "Gray Code",
    "MEX of all Subarrays",
    "Dates",
    "Schreier–Sims Algorithm",
    "Expression Parsing",
    "Randomized Algorithms",
    "K-th Root of a Permutation",
    "Matroid Intersection",
    "SMAWK Algorithm",
    "Lindstrom–Gessel–Viennot lemma"
]



export const difficulty = [
    0,
    1,
    2,
    3
];

export const difficultyOptions = [
    {
        value:0, label:0
    },
    {
        value:1, label:1
    },
    {
        value:2, label:2
    },
    {
        value:3, label:3
    }
];

export const categoryOptions = [
    {
        value:"Basics", label:"Basics"
    },
    {
        value:"Math", label:"Math"
    },
    {
        value:"Number Theory", label:"Number Theory"
    },
    {
        value:"Graph Theory", label:"Graph Theory"
    },
    {
        value:"Data Structures", label:"Data Structures"
    },
    {
        value:"Strings", label:"Strings"
    },
    {
        value:"DP", label:"DP"
    },
    {
        value:"Geometry", label:"Geometry"
    },
    {
        value:"Game Theory", label:"Game Theory"
    },
    {
        value:"Miscelleneous", label:"Miscelleneous"
    },
    {
        value:"Important Links", label:"Important Links"
    }
];

export const categories = [
    "Basics",
   "Math",
   "Number Theory",
   "Graph Theory",
    "Data Structures",
    "Strings",
    "DP",
    "Geometry",
    "Game Theory",
    "Miscelleneous",
    "Important Links"
];

export const showOptions = [
    {
        value:"", label:"All"
    },
    {
        value:"true", label:"Only Solved"

    },
    {
        value:"false", label:"Only Unsolved"
    },
];
